var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-panel"},[_c('van-panel',{attrs:{"title":_vm.title,"desc":_vm.desc}},[_vm._t("default",[_vm._v("contents")]),_vm._t("footer",[_vm._v("\n        footers\n    ")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }